import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  assetsTableContainer: {
    marginTop: "5px",
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
  },
  inlineButtons: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px",
  },
  sequencePageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
